import {Injectable} from "@angular/core";
import {CoreErrorHandlerBaseService} from "@core/services/error-handler-base/core-error-handler-base.service";
import {IAlertControllerCreate} from "@shared/interfaces/alert-controller-create.interface";

@Injectable({
  providedIn: 'root'
})
export class TeamErrorHandlerGuestLoginAcceptCodeService extends CoreErrorHandlerBaseService {

  override _formatAlertFor404(status: number): IAlertControllerCreate {
    this._errorText = this._translateService.instant("TEAM.WELCOME.ERRORS.DESCRIPTIONS.SOMETHING_WENT_WRONG");
    return {
      header: this._translateService.instant("TEAM.WELCOME.ERRORS.TITLES.SOMETHING_WENT_WRONG"),
      subHeader: '',
      message: this._translateService.instant("TEAM.WELCOME.ERRORS.DESCRIPTIONS.SOMETHING_WENT_WRONG"),
      buttons: [
        { text: this._translateService.instant("TEAM.WELCOME.BUTTONS.OK") }
      ]
    };
  }

  override _formatAlertFor400(status: number, name: string, message: string): IAlertControllerCreate {
    this._errorText = this._translateService.instant("TEAM.WELCOME.ERRORS.TITLES.SOMETHING_WENT_WRONG");
    const userNotFoundAlert = this._formatAlertForSpecialErrors(status, name, message as any);
    return {
      header: this._translateService.instant("TEAM.WELCOME.ERRORS.TITLES.SOMETHING_WENT_WRONG"),
      subHeader: '',
      message: this._translateService.instant("TEAM.WELCOME.ERRORS.DESCRIPTIONS.SOMETHING_WENT_WRONG"),
      buttons: [
        {
          text: this._translateService.instant("GENERAL.ALERT.BUTTONS.DETAILS"),
          handler: () => {
            this._alertControllerService.observableAlert(userNotFoundAlert);
          }
        },
        { text: this._translateService.instant("TEAM.WELCOME.BUTTONS.OK") }
      ]
    };
  }
}
